import { EditOutlined, SearchOutlined, PrinterOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Space,
  Table,
  Typography
} from "antd";



import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL, PRINT_BASE_NEW_URL } from "../../utility/URL";
import memberService from "../../api/member.service";
import { SUCCESS_STATUS } from "../../utility/Constants";
const { Text } = Typography;

const ReceiptHistoryComponent = (props) => {
  let navigate = useNavigate();
  const [receiptHistoryList, setReceiptHistoryList] = useState([]);

  const changeLocation = (placeToGo) => {

    navigate(placeToGo, { replace: true });
    window.location.reload();
  }


  const getReceiptHistory = (enrollment_id) => {
    console.log('receiptHistory');
    setReceiptHistoryList([]);
    const data = {
      formdata: {
        enrollment_id: enrollment_id,
      },
    };

    memberService.receiptHistory(data).then(
      (res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setReceiptHistoryList(res.data.response_data);
          console.log("receipthistory", res.data.response_data);

        }
      }
    );
  }


  useEffect(() => {
    if (props.enrollmentID > 0) {
      // console.log('props',props);
      getReceiptHistory(props.enrollmentID);
    }
  }, [props.enrollmentID]);

  const columns = [
    // {
    //     title: 'Program',
    //     dataIndex: 'short_code_text',
    //     key: 'short_code_text',

    //   },
    {
      title: 'Month',
      dataIndex: 'entry_from',
      key: 'entry_from',
      width: 'auto',
      render: (selectedObj, record) => (
        <Space style={{ whiteSpace: 'pre-wrap' }}>
          {
            record.entry_from == "A" ? "Membership/Admission" :
              record.entry_from == "B" ? "Booking" :
                record.entry_from == "M" ? record.short_name == 0 ? 'Security Deposit' : record.short_name + " " + record.year :
                  record.entry_from == "O" ? "Others" :
                    ""
          }
        </Space>
      ),
    },
    {
      title: 'Mode',
      dataIndex: 'payment_modes',
      key: 'payment_modes',
      width: 'auto',
      align: 'center', // centers the cell data
      titleAlign: 'center' // if you're using antd v5+
    },
    {
      title: 'Receipt',
      dataIndex: 'receipt_no',
      key: 'receipt_no',
      width: 'auto',
      align: 'center', // centers the cell data
      titleAlign: 'center' // if you're using antd v5+
    },
    {
      title: 'Date',
      dataIndex: 'receipt_date',
      key: 'receipt_date',
      width: 'auto',
      align: 'center', // centers the cell data
      titleAlign: 'center' // if you're using antd v5+
    },
    // {
    //   title: 'Due',
    //   dataIndex: 'due_amount',
    //   key: 'due_amount',
    // },
    //   {
    //     title: 'Group/Shift',
    //     dataIndex: 'programme_group',
    //     key: 'programme_group',
    //   },
    // {
    //   title: 'Name',
    //   dataIndex: 'member_fname',
    //   key: 'member_fname',
    //   sorter: (a, b) => {
    //     const nameA = `${a.member_fname} ${a.member_lname}`;
    //     const nameB = `${b.member_fname} ${b.member_lname}`;
    //     return nameA.localeCompare(nameB);
    //   },
    //   render: (selectedObj,record) => (
    //     <Space>
    //         <span>{record.member_fname} {record.member_lname}</span>
    //     </Space>
    //   ),

    // },
    /*
    {
      title: 'Primary Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'DOB',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
    },
    */

    //   {
    //     title: 'Validity',
    //     dataIndex: 'enrollment_start_date',
    //     key: 'enrollment_start_date',
    //     sorter: (a, b) => {
    //       const nameA = `${a.enrollment_start_date} ${a.enrollment_end_date}`;
    //       const nameB = `${b.enrollment_start_date} ${b.enrollment_end_date}`;
    //       return nameA.localeCompare(nameB);
    //     },
    //     render: (selectedObj,record) => (
    //       <Space>
    //           <span>{record.enrollment_start_date} to {record.enrollment_end_date}</span>
    //       </Space>
    //     ),

    //   },
    {
      title: 'Amount',
      dataIndex: 'receipt_dtl_taxable_amount',
      key: 'receipt_dtl_taxable_amount',
      align: 'right',
      render: (selectedObj, values) => (
        <div align="right">{commonUtility.sanitizeValue(values.receipt_dtl_taxable_amount).toFixed(2)} </div>
      ),
      width: 'auto',
    },


    {
      title: 'Action',
      key: 'action',
      titleAlign: 'center',
      align: 'center',
      width: 'auto',
      render: (selectedObj) => (
        <Space style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          {(selectedObj.short_code == "JCP") && (
            <a href={`/jcp-monthly/nongst/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="" danger disabled={selectedObj?.payment_mode_id === 8} ><EditOutlined /></Button>
            </a>
          )}
          {(selectedObj.short_code == "HP" || selectedObj.short_code == "JHP") && (
            <a href={`/hp-monthly/nongst/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="" danger disabled={selectedObj?.payment_mode_id === 8}><EditOutlined /></Button>
            </a>
          )}
          {(selectedObj.short_code == "PF") && (
            <a href={`/pf-monthly/nongst/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="" danger disabled={selectedObj?.payment_mode_id === 8}><EditOutlined /></Button>
            </a>
          )}

          {(selectedObj.entry_from == "A" && selectedObj.short_code == "TAP") && (
            // Render the first element if condition1 is true
            <a href={`${PRINT_BASE_URL}tap/tapreceipt/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
            </a>
          )}

          {(selectedObj.entry_from == "B" && selectedObj.short_code == "TAP") && (
            // Render the first element if condition1 is true
            <a href={`${PRINT_BASE_URL}tap/printpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
            </a>
          )}

          {(selectedObj.entry_from == "A" && selectedObj.short_code == "GYM") && (
            // Render the first element if condition1 is true
            <a href={`${PRINT_BASE_URL}tap/gymreceipt/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
            </a>
          )}

          {(selectedObj.short_code != "GYM" && selectedObj.short_code != "TAP") && (
            // Render the first element if condition1 is true
            <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
              <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /></Button>
            </a>
          )}


        </Space>
      ),
    },


  ];



  return (
    <>
      {
        receiptHistoryList.length > 0 ? <>

          <Col span={8}><Text underline style={{ fontWeight: 'bold', color: 'black' }}>Receipt History</Text></Col>
          <Col span={4} offset={12}>
            <Space>
              {/* Instructed By Sandip */}
              {/* <a
                href={`${PRINT_BASE_URL}member/print_member_receipt_new/${props.enrollmentID}/${props.memberID}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  htmlType="button"
                  type="ghost"
                  size="small"
                  shape="round"
                  style={{ backgroundColor: 'green', color: 'white' }}
                  icon={<PrinterOutlined />}
                >
                  New
                </Button>
              </a> */}
              {/* Instructed By Sandip */}
              <a
                // href={`${PRINT_BASE_URL}member/print_member_receipt/${props.enrollmentID}/${props.memberID}`} Commented on 08-07-2025
                href={`${PRINT_BASE_URL}otherreport/printpdfenrolment/${props.enrollmentID}/${props.yearID}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  htmlType="button"
                  type="primary"
                  size="small"
                  shape="round"
                  icon={<PrinterOutlined />}
                >
                  Print
                </Button>
              </a>
            </Space>
          </Col>

          <Space className="receipt-history">
            <Table columns={columns} rowKey='receipt_id' dataSource={receiptHistoryList} size="small" pagination={false} style={{ fontSize: '10px' }} scroll={{ y: 250 }} tableLayout="auto" />
          </Space>

        </> : <></>
      }

    </>
  );
};

export default ReceiptHistoryComponent;
